// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.particles {
  z-index: 99999;
  padding: var(--base-sizes-4);
  background: linear-gradient(to top right, #003865 0%, #01214a 100%);
  flex-direction: column;
  flex: auto;
  justify-content: center;
  align-items: center;
  display: flex;
  position: absolute;
  inset: 0;
  min-height: inherit !important;
}

.particles #ConeLight {
  animation: .6s infinite coneCycle;
  fill: orange !important;
}

@keyframes coneCycle {
  50% {
    fill: #fff;
  }

  100% {
    fill: #d62209;
  }
}

.particles #CraneLight {
  fill: #fff;
  animation: .6s infinite coneCycle;
}

.particles #Winch {
  animation: 4s linear infinite alternate-reverse winchCycle;
  transform: translateX(88px);
}

@keyframes winchCycle {
  0% {
    transform: translateX(88px);
  }

  100% {
    transform: translateX(4px);
  }
}

.particles #PaintRoller {
  animation: .7s infinite alternate-reverse paintRoller;
  transform: translateY(-1px);
}

@keyframes paintRoller {
  0% {
    transform: translateY(-7px);
  }

  100% {
    transform: translateY(21px);
  }
}

.particles-animation {
  z-index: 0;
  position: absolute;
  inset: 0;
}

.particles-logo {
  z-index: 1;
  opacity: .25;
  height: 30vh;
  max-height: 200px;
  position: absolute;
  bottom: 0;
  left: 0;
}

.particles-content {
  color: #fff;
  z-index: 2;
}

.particles-text a {
  color: #72afd2;
}

.particles-text a:hover {
  color: #afbeca;
}

.particles-title {
  margin-top: var(--base-sizes-5);
  margin-bottom: var(--base-sizes-5);
  font-family: Helvetica, sans-serif;
  font-size: 50px;
  font-weight: bold;
}

.particles-text {
  font-family: Helvetica, sans-serif;
  font-size: 20px;
}

.particles-content-auto-width {
  width: auto;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/Particles/Particles.css","webpack://./services/frontend/app/components/Particles/Particles.css"],"names":[],"mappings":"AADA;ECEE,cAAc;EACd,4BAA4B;EAC5B,mEAAmE;EACnE,sBAAsB;EACtB,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,0DAA0D;EAC1D,2BAA2B;AAC7B;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;AAC7B;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,OAAO;AACT;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,kCAAkC;EAClC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".particles {\n  align-items: center;\n  background: linear-gradient(to top right, #003865 0%, #01214a 100%);\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  justify-content: center;\n  min-height: inherit !important;\n  position: absolute;\n  inset: 0;\n  z-index: 99999;\n  padding: var(--base-sizes-4);\n}\n\n  .particles #ConeLight {\n    fill: orange !important;\n    animation: 0.6s infinite coneCycle;\n  }\n\n  @keyframes coneCycle {\n    50% {\n      fill: white;\n    }\n\n    100% {\n      fill: #d62209;\n    }\n  }\n\n  /* Crane Light Animation */\n\n  .particles #CraneLight {\n    fill: white;\n    animation: 0.6s infinite coneCycle;\n  }\n\n  /* Crane Whinch Animation */\n\n  .particles #Winch {\n    transform: translateX(88px);\n    animation: 4s linear infinite winchCycle;\n    animation-direction: alternate-reverse;\n  }\n\n  @keyframes winchCycle {\n    0% {\n      transform: translateX(88px);\n    }\n\n    100% {\n      transform: translateX(4px);\n    }\n  }\n\n  /* Paint Roller Animation */\n\n  .particles #PaintRoller {\n    animation: 0.7s ease infinite paintRoller;\n    transform: translateY(-1px);\n    animation-direction: alternate-reverse;\n  }\n\n  @keyframes paintRoller {\n    0% {\n      transform: translateY(-7px);\n    }\n\n    100% {\n      transform: translateY(21px);\n    }\n  }\n\n.particles-animation {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 0;\n}\n\n.particles-logo {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  z-index: 1;\n  height: 30vh;\n  max-height: 200px;\n  opacity: 0.25;\n}\n\n.particles-content {\n  color: #fff;\n  z-index: 2;\n}\n\n.particles-text a {\n  color: #72afd2;\n}\n\n.particles-text a:hover {\n    color: #afbeca;\n  }\n\n.particles-title {\n  margin-top: var(--base-sizes-5);\n  margin-bottom: var(--base-sizes-5);\n\n  font-size: 50px;\n  font-family: Helvetica, sans-serif;\n  font-weight: bold;\n}\n\n.particles-text {\n  font-size: 20px;\n  font-family: Helvetica, sans-serif;\n}\n\n.particles-content-auto-width {\n  width: auto;\n}\n",".particles {\n  z-index: 99999;\n  padding: var(--base-sizes-4);\n  background: linear-gradient(to top right, #003865 0%, #01214a 100%);\n  flex-direction: column;\n  flex: auto;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  position: absolute;\n  inset: 0;\n  min-height: inherit !important;\n}\n\n.particles #ConeLight {\n  animation: .6s infinite coneCycle;\n  fill: orange !important;\n}\n\n@keyframes coneCycle {\n  50% {\n    fill: #fff;\n  }\n\n  100% {\n    fill: #d62209;\n  }\n}\n\n.particles #CraneLight {\n  fill: #fff;\n  animation: .6s infinite coneCycle;\n}\n\n.particles #Winch {\n  animation: 4s linear infinite alternate-reverse winchCycle;\n  transform: translateX(88px);\n}\n\n@keyframes winchCycle {\n  0% {\n    transform: translateX(88px);\n  }\n\n  100% {\n    transform: translateX(4px);\n  }\n}\n\n.particles #PaintRoller {\n  animation: .7s infinite alternate-reverse paintRoller;\n  transform: translateY(-1px);\n}\n\n@keyframes paintRoller {\n  0% {\n    transform: translateY(-7px);\n  }\n\n  100% {\n    transform: translateY(21px);\n  }\n}\n\n.particles-animation {\n  z-index: 0;\n  position: absolute;\n  inset: 0;\n}\n\n.particles-logo {\n  z-index: 1;\n  opacity: .25;\n  height: 30vh;\n  max-height: 200px;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n}\n\n.particles-content {\n  color: #fff;\n  z-index: 2;\n}\n\n.particles-text a {\n  color: #72afd2;\n}\n\n.particles-text a:hover {\n  color: #afbeca;\n}\n\n.particles-title {\n  margin-top: var(--base-sizes-5);\n  margin-bottom: var(--base-sizes-5);\n  font-family: Helvetica, sans-serif;\n  font-size: 50px;\n  font-weight: bold;\n}\n\n.particles-text {\n  font-family: Helvetica, sans-serif;\n  font-size: 20px;\n}\n\n.particles-content-auto-width {\n  width: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
